<template>
	<div class="fixed-overlay card">

		<div class="fixed-overlay__header">
			{{header}}
		</div>

		<div class="fixed-overlay__text" v-html="text" />

		<Lottie
					:animationpath="visual"
					name="intro-animation"
					loop="true"
					ratio="meet"
					autoplay="true"
					style="margin:auto; position: relative"
					v-if="visualExists && visualIsJson"
			/>


		<div @click="onClick" class="btn btn-progres">
			Verder
		</div>
	</div>
</template>

<script>

	import Lottie from '../../Lottie.vue';

	export default {
		components:{
			Lottie,
		},

		props: [
			'onClick',
			'header',
			'text',
			'visual',
		],

		data(){
			return{
			}
		},

		mounted(){
		},

		watch:{
		},

		computed: {

		},

		methods:{


			visualExists(){
				return this.visual != null;
			},

			visualIsJson(){
				if(this.visual == null) return false;
				let fileExtension = this.visual.substr(this.visual.lastIndexOf('.') + 1);
				return fileExtension.toLowerCase() == 'json';
			},

		},

	}
</script>

<style scoped>
	/*.fixed-overlay {*/
		/*position: absolute;*/ /* Sit on top of the page content */
		/*width: 100%;*/ /* Full width (cover the whole page) */
		/*height: 100%;*/ /* Full height (cover the whole page) */
		/*top: 0;*/
		/*left: 0;*/
		/*right: 0;*/
		/*bottom: 0;*/
		/*background-color: rgba(0,0,0,0.9);*/ /* Black background with opacity */
		/*z-index: 3;*/ /* Specify a stack order in case you're using a different order for other elements */
		/*color: #fff;*/
	/*}*/

	/*.fixed-overlay__text{
		position: relative;
		left: 10%;
		width: 80%;
		height: auto;
		padding: 20px 0px;
	}

	.fixed-overlay__header{
		position: relative;
		left: 10%;
		width: 80%;
		height: auto;
		padding: 20px 0px 40px 0px;
		text-align: center;
		font-size: 34px;
	}

	.fixed-overlay__button{
		position: absolute;
		top: calc(100% - 80px);
		left: 30%;
		width: 40%;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		color: #0b2e3b;
		text-align: center;
		border-radius: 5px;
		cursor: pointer;*/ /* Add a pointer on hover 
	/*}*/

</style>


// WEBPACK FOOTER //
// src/components/minigames/simonsays/Overlay.vue